import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	exportCsvButtonLabel: {
		id: 'servicedesk-kb-requests-reports.export-csv.export-csv-button-label',
		defaultMessage: 'Export CSV',
		description: 'label for Export CSV button',
	},
});
